// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RcDRs9qQqYoka1PA {
  max-width: 1315px;
  margin: 0 auto;
  padding-bottom: 96px;
}

.JQFNr2nfO3c9C0gJ {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BBF2Uk2nNkwEsSWA {
  width: 290px;
  padding: 12px 10px;
  border-radius: 16px;
}

.Y45RwsiCdkUiWQTT {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.ulhTbWvVVcza2fVz {
  display: flex;
  align-items: center;
}

.I_KMVOg9BicXxGHZ {
  margin-right: 10px;
}

.RRsNgNubiqg90YTc {
  color: #000000;
  background-color: transparent;
  border: none;
  font-style: italic;
  cursor: pointer;
}

.RRsNgNubiqg90YTc i {
  font-size: 16px;
  background-color: #4d87be;
  color: #ffffff;
  padding: 10px;
  border-radius: 8px;
  margin-right: 12px;
}

.leZC90SN5IIhXR4d {
  color: #000000;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.leZC90SN5IIhXR4d i {
  font-size: 16px;
  background-color: #56be4d;
  color: #ffffff;
  padding: 10px;
  border-radius: 8px;
  margin-left: 12px;
}

.c0nh_l3MfIEGYbpo {
  border: 1px dashed #aa1919;
  border-radius: 8px;
  background-color: pink;
  color: #aa1919;
  padding: 10px 40px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.FYA6W8TzDs80VQQx .fc-timegrid-slot {
  line-height: 12px;
  height: auto;
}

.FYA6W8TzDs80VQQx .fc-day-today {
  background-color: inherit !important;
}

.FYA6W8TzDs80VQQx .fc-col-header-cell-cushion {
  color: #303030;
}
.FYA6W8TzDs80VQQx .fc-timegrid-slot-label-cushion {
  color: #303030;
}

.FYA6W8TzDs80VQQx .fc-event {
  border-radius: 8px;
  padding-top: 8px;
}

.W2KH_loQREi3aqyN {
  display: none;
}

.yMuW4J7rBlkJdAsk {
  width: 541px !important;
  height: 354px !important;
  background-color: #f3f5f7;
  border-radius: 25px !important;
}

.yMuW4J7rBlkJdAsk .p-dialog {
  border-radius: 25px !important;
  background-color: #f3f5f7;
}

.yMuW4J7rBlkJdAsk .p-dialog-footer {
  border-bottom-right-radius: 25px !important;
  border-bottom-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.yMuW4J7rBlkJdAsk .p-dialog-header {
  border-top-right-radius: 25px !important;
  border-top-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.yMuW4J7rBlkJdAsk .p-dialog-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.yMuW4J7rBlkJdAsk .S4jtA2TpTioWQSiD {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
}

.yMuW4J7rBlkJdAsk .p-dialog-content {
  background-color: #f3f5f7;
}

.yMuW4J7rBlkJdAsk .p-dialog-title {
  font-size: 1.875rem !important;
  font-weight: 700 !important;
}

.hxOhZOTSc7IkzY9y {
  width: 100%;
  background-color: #4d87be;
  border-radius: 16px;
  padding: 18px 20px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  border: none;
}

.hxOhZOTSc7IkzY9y:hover {
  background-color: #20336c;
}

.epPiET8eVIMmktj1 {
  width: 100%;
  background-color: #f3f5f7;
  border-radius: 16px;
  padding: 10px 20px;
  color: #4d87be;
  font-size: 20px;
  font-weight: 600;
  border: none;
}

.epPiET8eVIMmktj1:hover {
  color: #305375;
}

/* Prevent PrimeReact from greying out / fading the disabled group-header rows */
.FEttFQmJH8LYdOlL .p-dropdown-item.p-disabled {
  opacity: 1;
  cursor: default;
  pointer-events: none;
}
.FEttFQmJH8LYdOlL .p-dropdown-item.p-disabled:hover {
  background: transparent;
}

.ree0GQeW9QAqySNu {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #888;
}

.Goy6yixXzk3axnwZ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background: #20336c;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  font-family: Roboto, sans-serif;
  border-radius: 4px;
  flex-shrink: 0;
}

.roZ0EtjDT4IuyfJj {
  padding-left: 12px;
}

.YnC6PAsbUUA4LiTg {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.hIdegu3H90ajfyz3 {
  background-color: #4d87be;
  font-size: 16px;
  font-weight: 500;
  font-family: Roboto;
  border-radius: 10px;
  max-height: 35px;
  flex-shrink: 0;
}

.fM0I_G5fATI2nFWq {
  border-radius: 10px;
  max-height: 35px;
  font-size: 16px;
  font-weight: 500;
  font-family: Roboto;
  flex-shrink: 0;
  background-color: #4d87be;
  border: none;
  color: #fff;
}

.fM0I_G5fATI2nFWq .p-dropdown-label {
  font-size: 16px;
  font-weight: 500;
  font-family: Roboto;
  color: #fff;
  padding-top: 6px;
  padding-bottom: 6px;
}

.fM0I_G5fATI2nFWq .p-dropdown-trigger {
  color: #fff;
}

.fM0I_G5fATI2nFWq:hover,
.fM0I_G5fATI2nFWq:focus-within {
  background-color: #3a6fa3;
  border: none;
  box-shadow: none;
}

.zBmtHL2UEXQ3Za5i .p-dropdown-item {
  font-size: 13px;
  font-family: Roboto;
  white-space: normal;
}

.OF9EA2ZHZP0YP9li {
  overflow-x: auto;
  width: 100%;
}

.J9SdydU7uA0h2ZDR {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #303030;
  padding: 8px 10px 4px;
}

.bQqcIMw6g1YIQAkp {
  margin-left: 12px;
  border-left: 3px solid #e0e0e0;
}

.SRTGMONRvoZXZnBl {
  background: #fff;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 16px;
  min-width: 600px;
}

.hK8i7XV9re8LTjcL {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 30px;
  height: fit-content !important;
  padding: 10px;
}

.hK8i7XV9re8LTjcL h4 {
  font-size: 1.875rem !important;
  font-weight: 700 !important;
  margin: 0;
}

.IFaJcpsyjEg6rJnp {
  display: flex;
  align-items: center;
  gap: 10px;
}

.IwlZByC8W2Qpn3ZP {
  height: 70vh !important;
  background-color: #f3f5f7;
  border-radius: 25px !important;
}

.IwlZByC8W2Qpn3ZP .p-dialog {
  border-radius: 25px !important;
  background-color: #f3f5f7;
}

.IwlZByC8W2Qpn3ZP .p-dialog-footer {
  border-bottom-right-radius: 25px !important;
  border-bottom-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.IwlZByC8W2Qpn3ZP .p-dialog-header {
  border-top-right-radius: 25px !important;
  border-top-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.IwlZByC8W2Qpn3ZP .p-dialog-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-bottom-right-radius: 25px !important;
  border-bottom-left-radius: 25px !important;
}

.IwlZByC8W2Qpn3ZP .p-dialog-content {
  background-color: #f3f5f7;
}

.IwlZByC8W2Qpn3ZP .p-dialog-title {
  font-size: 1.875rem !important;
  font-weight: 700 !important;
}

@media screen and (max-width: 930px) {
  .hK8i7XV9re8LTjcL {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .hK8i7XV9re8LTjcL h4 {
    font-size: 1.25rem !important;
  }

  .IFaJcpsyjEg6rJnp {
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 8px;
  }

  .SRTGMONRvoZXZnBl {
    min-width: 100%;
    padding: 8px;
  }

  .IwlZByC8W2Qpn3ZP {
    height: 90vh !important;
    width: 95% !important;
    margin: 0 auto;
  }

  .IwlZByC8W2Qpn3ZP .p-dialog-content {
    padding: 0.5rem;
  }
}

@media screen and (max-width: 790px) {
  .JQFNr2nfO3c9C0gJ {
    flex-direction: column;
    align-items: start;
  }

  .fM0I_G5fATI2nFWq {
    padding-right: 6px;
  }

  .BBF2Uk2nNkwEsSWA .p-dropdown-trigger {
    width: 12px;
  }

  .fM0I_G5fATI2nFWq .p-dropdown-trigger {
    width: 12px;
  }

  .FYA6W8TzDs80VQQx {
    margin-top: 26px;
  }

  .W2KH_loQREi3aqyN {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 26px;
    margin-bottom: 26px;
  }

  .YYcuqxaJ7EQk3MR_ {
    padding: 10px 12px;
    border: none;
    border-radius: 8px;
    background: transparent;
    cursor: pointer;
    text-align: center;
    color: #333;
    transition: background 0.2s ease;
    display: flex;
    flex-direction: column;
  }

  .YYcuqxaJ7EQk3MR_ span {
    font-size: 12px;
    font-weight: 300;
  }

  .YYcuqxaJ7EQk3MR_.ZkJC_81rvUo6Gt1_ {
    background-color: #fbe8c6;
  }

  .Y45RwsiCdkUiWQTT {
    position: relative;
    width: fit-content;
    margin: 0 auto;
    justify-content: center;
    margin-bottom: 0;
  }

  .MObukh2ouDULzNZD {
    max-width: 296px;
  }

  .kZF6N_DhccovL_oA {
    position: absolute;
    left: -66px;
    bottom: 0;
    flex-shrink: 0;
  }

  .kZF6N_DhccovL_oA button {
    padding: 0 !important;
  }

  .MObukh2ouDULzNZD span:first-child {
    font-size: 12px;
    font-weight: 300;
    font-style: italic;
    color: #7b7b7b;
  }

  .RRsNgNubiqg90YTc {
    width: 100%;
  }

  .RRsNgNubiqg90YTc i {
    width: 100%;
    color: #fff;
    background-color: #58a4a4;
    padding: 20px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .RRsNgNubiqg90YTc span {
    display: none;
  }

  .c0nh_l3MfIEGYbpo {
    position: absolute;
    left: -132px;
    bottom: 0;
    flex-shrink: 0;
    margin: 0;
    padding: 0 !important;
    width: 56px;
    height: 56px;
  }

  .c0nh_l3MfIEGYbpo i {
    margin-right: 0 !important;
  }

  .c0nh_l3MfIEGYbpo span {
    display: none;
  }

  .leZC90SN5IIhXR4d i {
    margin-right: 0 !important;
    padding: 20px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
  }

  .leZC90SN5IIhXR4d span {
    display: none;
  }

  .FYA6W8TzDs80VQQx {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }

  .FYA6W8TzDs80VQQx .fc {
    width: 70%;
  }

  .FYA6W8TzDs80VQQx .fc thead {
    display: none;
  }

  .FYA6W8TzDs80VQQx .fc-event {
    border-radius: 0 8px 8px 0;
    padding-left: 19px;
    width: 100%;
  }

  .FYA6W8TzDs80VQQx .fc-event.drag-resize {
    width: 40% !important;
    height: 40% !important;
  }

  .FYA6W8TzDs80VQQx .fc-event::before {
    content: "";
    margin-left: -25px;
    margin-top: -11px;
    width: 1px;
    padding: 4px;
    height: 100.7%;
    background-color: #306060;
    border-radius: 5px !important;
    display: block;
    position: absolute;
  }

  .FYA6W8TzDs80VQQx .fc-event.fc-event-selected::before {
    margin-left: 4px;
    margin-top: -3px;
  }

  .FYA6W8TzDs80VQQx .fc-col-header-cell-cushion {
    color: #899bad;
  }
  .FYA6W8TzDs80VQQx .fc-timegrid-slot-label-cushion {
    color: #899bad;
  }

  .FYA6W8TzDs80VQQx .fc table,
  .FYA6W8TzDs80VQQx .fc td,
  .FYA6W8TzDs80VQQx .fc th {
    border-style: none;
  }

  .FYA6W8TzDs80VQQx .fc .fc-timegrid-slot-label {
    border-right: #a4b7ca 1px solid !important;
    margin-right: 5px;
  }

  .FYA6W8TzDs80VQQx .fc .fc-timegrid-body {
    margin-top: 10px;
  }
}

@media screen and (max-width: 644px) {
  .MObukh2ouDULzNZD {
    margin: 0;
  }
}

@media screen and (max-width: 570px) {
  .FYA6W8TzDs80VQQx {
    display: block;
  }

  .FYA6W8TzDs80VQQx .fc {
    width: 100%;
  }

  .Y45RwsiCdkUiWQTT {
    width: 100%;
    max-width: 515px;
    justify-content: end;
  }

  .kZF6N_DhccovL_oA {
    left: 0;
  }

  .c0nh_l3MfIEGYbpo {
    left: 66px;
  }

  .BBF2Uk2nNkwEsSWA {
    width: 200px;
    padding: 6px 6px;
  }

  .MObukh2ouDULzNZD i {
    margin-right: 0 !important;
  }
}

@media screen and (max-width: 520px) {
  .JQFNr2nfO3c9C0gJ {
    flex-direction: column;
    align-items: start;
  }

  .YnC6PAsbUUA4LiTg {
    gap: 6px;
  }

  .BBF2Uk2nNkwEsSWA {
    width: 100%;
    max-width: 180px;
    font-size: 14px !important;
    border-radius: 16px;
    padding: 4px 6px;
    height: 44px;
  }

  .BBF2Uk2nNkwEsSWA::placeholder {
    font-size: 14px;
  }
}

@media screen and (max-width: 424px) {
  .W2KH_loQREi3aqyN {
    gap: 4px;
  }

  .YYcuqxaJ7EQk3MR_ {
    padding: 8px 10px;
  }

  .YYcuqxaJ7EQk3MR_ span {
    font-size: 12px;
    font-weight: 300;
  }
}

@media screen and (max-width: 378px) {
  .W2KH_loQREi3aqyN {
    gap: 3px;
  }

  .YYcuqxaJ7EQk3MR_ {
    padding: 4px 6px;
  }

  .kZF6N_DhccovL_oA {
    max-width: 48px !important;
    max-height: 56px !important;
  }

  .leZC90SN5IIhXR4d i {
    margin-left: 0;
    margin-top: 2px;
  }
}

@media print {
  /* Hide everything except the dialog content */
  body * {
    visibility: hidden;
  }

  /* Show only the table modal and its contents */
  .IwlZByC8W2Qpn3ZP,
  .IwlZByC8W2Qpn3ZP *,
  .OF9EA2ZHZP0YP9li,
  .OF9EA2ZHZP0YP9li *,
  .SRTGMONRvoZXZnBl,
  .SRTGMONRvoZXZnBl * {
    visibility: visible;
  }

  .QJGk83VAn4Y9HySU,
  .CK2__HNeQmg800iG,
  .IwlZByC8W2Qpn3ZP,
  .OF9EA2ZHZP0YP9li {
    overflow: visible !important;
  }

  .IwlZByC8W2Qpn3ZP {
    position: static !important;
    width: 100% !important;
    height: auto !important;
    max-width: none !important;
    max-height: none !important;
    background-color: #fff !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .IwlZByC8W2Qpn3ZP .p-dialog {
    position: static !important;
    border-radius: 0 !important;
    background-color: #fff !important;
    box-shadow: none !important;
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    height: auto !important;
    max-width: none !important;
    max-height: none !important;
  }

  .IwlZByC8W2Qpn3ZP .p-dialog-footer {
    display: none !important;
  }

  .IwlZByC8W2Qpn3ZP .p-dialog-header {
    display: none !important;
  }

  .IwlZByC8W2Qpn3ZP .p-dialog-content {
    display: block !important;
    flex-direction: unset !important;
    align-items: unset !important;
    justify-content: unset !important;
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
    background-color: #fff !important;
  }

  .IwlZByC8W2Qpn3ZP {
    position: static !important;
    display: block !important;
    width: 100% !important;
    height: auto !important;
    overflow: visible !important;
    background-color: #fff !important;
  }

  .OF9EA2ZHZP0YP9li {
    display: block !important;
    overflow: visible !important;
    width: 100% !important;
  }

  .SRTGMONRvoZXZnBl {
    background: #fff !important;
    padding: 20px !important;
    border-radius: 0 !important;
    margin-bottom: 30px !important;
    border: 1px solid #ddd !important;
    break-inside: avoid-page;
    page-break-inside: avoid;
  }

  .SRTGMONRvoZXZnBl h3 {
    color: #000 !important;
    font-size: 18px !important;
    margin-bottom: 15px !important;
    font-weight: bold !important;
  }

  .SRTGMONRvoZXZnBl .p-datatable {
    border: 1px solid #ddd !important;
  }

  .SRTGMONRvoZXZnBl .p-datatable-thead {
    background-color: #f5f5f5 !important;
  }

  .SRTGMONRvoZXZnBl .p-datatable-table {
    table-layout: fixed !important;
    width: 100% !important;
    border-radius: 0 !important;
  }

  .SRTGMONRvoZXZnBl .p-datatable-thead th,
  .SRTGMONRvoZXZnBl .p-datatable-tbody td {
    width: 14.28% !important;
    word-wrap: break-word;
  }

  .SRTGMONRvoZXZnBl .p-datatable-thead th {
    background-color: #f5f5f5 !important;
    color: #000 !important;
    border: 1px solid #ddd !important;
    padding: 12px 8px !important;
    font-weight: bold !important;
    font-size: 14px !important;
  }

  .SRTGMONRvoZXZnBl .p-datatable-tbody td {
    border: 1px solid #ddd !important;
    padding: 10px 8px !important;
    color: #000 !important;
    background-color: #fff !important;
    font-size: 14px !important;
  }

  .SRTGMONRvoZXZnBl .p-datatable-tbody tr:nth-child(even) {
    background-color: #fff !important;
  }

  @page {
    margin: 1in;
    size: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/Scheduling.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,cAAc;IACd,SAAS;IACT,qBAAqB;IACrB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,6BAA6B;IAC7B,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,0CAA0C;IAC1C,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,8CAA8C;EAC9C;IACE,kBAAkB;EACpB;;EAEA,+CAA+C;EAC/C;;;;;;IAME,mBAAmB;EACrB;;EAEA;;;;IAIE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,iCAAiC;IACjC,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,iCAAiC;IACjC,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;IAChC,6BAA6B;IAC7B,iCAAiC;IACjC,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,wBAAwB;IACxB,2BAA2B;IAC3B,8BAA8B;IAC9B,iCAAiC;IACjC,wBAAwB;IACxB,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;;IAEE,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,oCAAoC;IACpC,sBAAsB;IACtB,iCAAiC;IACjC,4BAA4B;IAC5B,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,iCAAiC;IACjC,4BAA4B;IAC5B,sBAAsB;IACtB,iCAAiC;IACjC,0BAA0B;EAC5B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;AACF","sourcesContent":[".pageWrapper {\r\n  max-width: 1315px;\r\n  margin: 0 auto;\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.pageHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.dropdown {\r\n  width: 290px;\r\n  padding: 12px 10px;\r\n  border-radius: 16px;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.left {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.toggleWrapper {\r\n  margin-right: 10px;\r\n}\r\n\r\n.dragCreateBtn {\r\n  color: #000000;\r\n  background-color: transparent;\r\n  border: none;\r\n  font-style: italic;\r\n  cursor: pointer;\r\n}\r\n\r\n.dragCreateBtn i {\r\n  font-size: 16px;\r\n  background-color: #4d87be;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  margin-right: 12px;\r\n}\r\n\r\n.saveBtn {\r\n  color: #000000;\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.saveBtn i {\r\n  font-size: 16px;\r\n  background-color: #56be4d;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  margin-left: 12px;\r\n}\r\n\r\n.deleteSlot {\r\n  border: 1px dashed #aa1919;\r\n  border-radius: 8px;\r\n  background-color: pink;\r\n  color: #aa1919;\r\n  padding: 10px 40px;\r\n  margin-left: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.calendarWrapper :global(.fc-timegrid-slot) {\r\n  line-height: 12px;\r\n  height: auto;\r\n}\r\n\r\n.calendarWrapper :global(.fc-day-today) {\r\n  background-color: inherit !important;\r\n}\r\n\r\n.calendarWrapper :global(.fc-col-header-cell-cushion) {\r\n  color: #303030;\r\n}\r\n.calendarWrapper :global(.fc-timegrid-slot-label-cushion) {\r\n  color: #303030;\r\n}\r\n\r\n.calendarWrapper :global(.fc-event) {\r\n  border-radius: 8px;\r\n  padding-top: 8px;\r\n}\r\n\r\n.weekdaySwitcher {\r\n  display: none;\r\n}\r\n\r\n.alertModal {\r\n  width: 541px !important;\r\n  height: 354px !important;\r\n  background-color: #f3f5f7;\r\n  border-radius: 25px !important;\r\n}\r\n\r\n.alertModal :global(.p-dialog) {\r\n  border-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.alertModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 25px !important;\r\n  border-bottom-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.alertModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 25px !important;\r\n  border-top-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.alertModal :global(.p-dialog-content) {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.alertModal .text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n}\r\n\r\n.alertModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.alertModal :global(.p-dialog-title) {\r\n  font-size: 1.875rem !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.confirmDialogBtn {\r\n  width: 100%;\r\n  background-color: #4d87be;\r\n  border-radius: 16px;\r\n  padding: 18px 20px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  border: none;\r\n}\r\n\r\n.confirmDialogBtn:hover {\r\n  background-color: #20336c;\r\n}\r\n\r\n.cancelDialogBtn {\r\n  width: 100%;\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px;\r\n  padding: 10px 20px;\r\n  color: #4d87be;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  border: none;\r\n}\r\n\r\n.cancelDialogBtn:hover {\r\n  color: #305375;\r\n}\r\n\r\n/* Prevent PrimeReact from greying out / fading the disabled group-header rows */\r\n.scheduleDropdownPanel :global(.p-dropdown-item.p-disabled) {\r\n  opacity: 1;\r\n  cursor: default;\r\n  pointer-events: none;\r\n}\r\n.scheduleDropdownPanel :global(.p-dropdown-item.p-disabled:hover) {\r\n  background: transparent;\r\n}\r\n\r\n.dropdownGroupHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  color: #888;\r\n}\r\n\r\n.dropdownGroupBadge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 16px;\r\n  height: 16px;\r\n  background: #20336c;\r\n  color: #fff;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  font-family: Roboto, sans-serif;\r\n  border-radius: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dropdownSubItem {\r\n  padding-left: 12px;\r\n}\r\n\r\n.selectorWrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 16px;\r\n}\r\n\r\n.scheduleTableBtn {\r\n  background-color: #4d87be;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  font-family: Roboto;\r\n  border-radius: 10px;\r\n  max-height: 35px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.scheduleFilterDropdown {\r\n  border-radius: 10px;\r\n  max-height: 35px;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  font-family: Roboto;\r\n  flex-shrink: 0;\r\n  background-color: #4d87be;\r\n  border: none;\r\n  color: #fff;\r\n}\r\n\r\n.scheduleFilterDropdown :global(.p-dropdown-label) {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  font-family: Roboto;\r\n  color: #fff;\r\n  padding-top: 6px;\r\n  padding-bottom: 6px;\r\n}\r\n\r\n.scheduleFilterDropdown :global(.p-dropdown-trigger) {\r\n  color: #fff;\r\n}\r\n\r\n.scheduleFilterDropdown:hover,\r\n.scheduleFilterDropdown:focus-within {\r\n  background-color: #3a6fa3;\r\n  border: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.scheduleFilterDropdownPanel :global(.p-dropdown-item) {\r\n  font-size: 13px;\r\n  font-family: Roboto;\r\n  white-space: normal;\r\n}\r\n\r\n.scheduleTablesWrapper {\r\n  overflow-x: auto;\r\n  width: 100%;\r\n}\r\n\r\n.multiStationSectionLabel {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: #303030;\r\n  padding: 8px 10px 4px;\r\n}\r\n\r\n.scheduleTableSub {\r\n  margin-left: 12px;\r\n  border-left: 3px solid #e0e0e0;\r\n}\r\n\r\n.scheduleTable {\r\n  background: #fff;\r\n  padding: 10px;\r\n  border-radius: 10px;\r\n  margin-bottom: 16px;\r\n  min-width: 600px;\r\n}\r\n\r\n.modalHeaderWrapper {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  gap: 30px;\r\n  height: fit-content !important;\r\n  padding: 10px;\r\n}\r\n\r\n.modalHeaderWrapper h4 {\r\n  font-size: 1.875rem !important;\r\n  font-weight: 700 !important;\r\n  margin: 0;\r\n}\r\n\r\n.modalHeaderBts {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.tableModal {\r\n  height: 70vh !important;\r\n  background-color: #f3f5f7;\r\n  border-radius: 25px !important;\r\n}\r\n\r\n.tableModal :global(.p-dialog) {\r\n  border-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.tableModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 25px !important;\r\n  border-bottom-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.tableModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 25px !important;\r\n  border-top-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.tableModal :global(.p-dialog-content) {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  border-bottom-right-radius: 25px !important;\r\n  border-bottom-left-radius: 25px !important;\r\n}\r\n\r\n.tableModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.tableModal :global(.p-dialog-title) {\r\n  font-size: 1.875rem !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n@media screen and (max-width: 930px) {\r\n  .modalHeaderWrapper {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 12px;\r\n  }\r\n\r\n  .modalHeaderWrapper h4 {\r\n    font-size: 1.25rem !important;\r\n  }\r\n\r\n  .modalHeaderBts {\r\n    width: 100%;\r\n    flex-wrap: wrap;\r\n    justify-content: flex-start;\r\n    gap: 8px;\r\n  }\r\n\r\n  .scheduleTable {\r\n    min-width: 100%;\r\n    padding: 8px;\r\n  }\r\n\r\n  .tableModal {\r\n    height: 90vh !important;\r\n    width: 95% !important;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .tableModal :global(.p-dialog-content) {\r\n    padding: 0.5rem;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 790px) {\r\n  .pageHeader {\r\n    flex-direction: column;\r\n    align-items: start;\r\n  }\r\n\r\n  .scheduleFilterDropdown {\r\n    padding-right: 6px;\r\n  }\r\n\r\n  .dropdown :global(.p-dropdown-trigger) {\r\n    width: 12px;\r\n  }\r\n\r\n  .scheduleFilterDropdown :global(.p-dropdown-trigger) {\r\n    width: 12px;\r\n  }\r\n\r\n  .calendarWrapper {\r\n    margin-top: 26px;\r\n  }\r\n\r\n  .weekdaySwitcher {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    margin-top: 26px;\r\n    margin-bottom: 26px;\r\n  }\r\n\r\n  .weekdayBtn {\r\n    padding: 10px 12px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    background: transparent;\r\n    cursor: pointer;\r\n    text-align: center;\r\n    color: #333;\r\n    transition: background 0.2s ease;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .weekdayBtn span {\r\n    font-size: 12px;\r\n    font-weight: 300;\r\n  }\r\n\r\n  .weekdayBtn.selected {\r\n    background-color: #fbe8c6;\r\n  }\r\n\r\n  .actions {\r\n    position: relative;\r\n    width: fit-content;\r\n    margin: 0 auto;\r\n    justify-content: center;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .createSlot {\r\n    max-width: 296px;\r\n  }\r\n\r\n  .saveBtnWrapper {\r\n    position: absolute;\r\n    left: -66px;\r\n    bottom: 0;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .saveBtnWrapper button {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .createSlot span:first-child {\r\n    font-size: 12px;\r\n    font-weight: 300;\r\n    font-style: italic;\r\n    color: #7b7b7b;\r\n  }\r\n\r\n  .dragCreateBtn {\r\n    width: 100%;\r\n  }\r\n\r\n  .dragCreateBtn i {\r\n    width: 100%;\r\n    color: #fff;\r\n    background-color: #58a4a4;\r\n    padding: 20px 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .dragCreateBtn span {\r\n    display: none;\r\n  }\r\n\r\n  .deleteSlot {\r\n    position: absolute;\r\n    left: -132px;\r\n    bottom: 0;\r\n    flex-shrink: 0;\r\n    margin: 0;\r\n    padding: 0 !important;\r\n    width: 56px;\r\n    height: 56px;\r\n  }\r\n\r\n  .deleteSlot i {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  .deleteSlot span {\r\n    display: none;\r\n  }\r\n\r\n  .saveBtn i {\r\n    margin-right: 0 !important;\r\n    padding: 20px !important;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n\r\n  .saveBtn span {\r\n    display: none;\r\n  }\r\n\r\n  .calendarWrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 20px;\r\n  }\r\n\r\n  .calendarWrapper :global(.fc) {\r\n    width: 70%;\r\n  }\r\n\r\n  .calendarWrapper :global(.fc thead) {\r\n    display: none;\r\n  }\r\n\r\n  .calendarWrapper :global(.fc-event) {\r\n    border-radius: 0 8px 8px 0;\r\n    padding-left: 19px;\r\n    width: 100%;\r\n  }\r\n\r\n  .calendarWrapper :global(.fc-event.drag-resize) {\r\n    width: 40% !important;\r\n    height: 40% !important;\r\n  }\r\n\r\n  .calendarWrapper :global(.fc-event::before) {\r\n    content: \"\";\r\n    margin-left: -25px;\r\n    margin-top: -11px;\r\n    width: 1px;\r\n    padding: 4px;\r\n    height: 100.7%;\r\n    background-color: #306060;\r\n    border-radius: 5px !important;\r\n    display: block;\r\n    position: absolute;\r\n  }\r\n\r\n  .calendarWrapper :global(.fc-event.fc-event-selected::before) {\r\n    margin-left: 4px;\r\n    margin-top: -3px;\r\n  }\r\n\r\n  .calendarWrapper :global(.fc-col-header-cell-cushion) {\r\n    color: #899bad;\r\n  }\r\n  .calendarWrapper :global(.fc-timegrid-slot-label-cushion) {\r\n    color: #899bad;\r\n  }\r\n\r\n  .calendarWrapper :global(.fc table),\r\n  .calendarWrapper :global(.fc td),\r\n  .calendarWrapper :global(.fc th) {\r\n    border-style: none;\r\n  }\r\n\r\n  .calendarWrapper :global(.fc .fc-timegrid-slot-label) {\r\n    border-right: #a4b7ca 1px solid !important;\r\n    margin-right: 5px;\r\n  }\r\n\r\n  .calendarWrapper :global(.fc .fc-timegrid-body) {\r\n    margin-top: 10px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 644px) {\r\n  .createSlot {\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 570px) {\r\n  .calendarWrapper {\r\n    display: block;\r\n  }\r\n\r\n  .calendarWrapper :global(.fc) {\r\n    width: 100%;\r\n  }\r\n\r\n  .actions {\r\n    width: 100%;\r\n    max-width: 515px;\r\n    justify-content: end;\r\n  }\r\n\r\n  .saveBtnWrapper {\r\n    left: 0;\r\n  }\r\n\r\n  .deleteSlot {\r\n    left: 66px;\r\n  }\r\n\r\n  .dropdown {\r\n    width: 200px;\r\n    padding: 6px 6px;\r\n  }\r\n\r\n  .createSlot i {\r\n    margin-right: 0 !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 520px) {\r\n  .pageHeader {\r\n    flex-direction: column;\r\n    align-items: start;\r\n  }\r\n\r\n  .selectorWrapper {\r\n    gap: 6px;\r\n  }\r\n\r\n  .dropdown {\r\n    width: 100%;\r\n    max-width: 180px;\r\n    font-size: 14px !important;\r\n    border-radius: 16px;\r\n    padding: 4px 6px;\r\n    height: 44px;\r\n  }\r\n\r\n  .dropdown::placeholder {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 424px) {\r\n  .weekdaySwitcher {\r\n    gap: 4px;\r\n  }\r\n\r\n  .weekdayBtn {\r\n    padding: 8px 10px;\r\n  }\r\n\r\n  .weekdayBtn span {\r\n    font-size: 12px;\r\n    font-weight: 300;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 378px) {\r\n  .weekdaySwitcher {\r\n    gap: 3px;\r\n  }\r\n\r\n  .weekdayBtn {\r\n    padding: 4px 6px;\r\n  }\r\n\r\n  .saveBtnWrapper {\r\n    max-width: 48px !important;\r\n    max-height: 56px !important;\r\n  }\r\n\r\n  .saveBtn i {\r\n    margin-left: 0;\r\n    margin-top: 2px;\r\n  }\r\n}\r\n\r\n@media print {\r\n  /* Hide everything except the dialog content */\r\n  body * {\r\n    visibility: hidden;\r\n  }\r\n\r\n  /* Show only the table modal and its contents */\r\n  .tableModal,\r\n  .tableModal *,\r\n  .scheduleTablesWrapper,\r\n  .scheduleTablesWrapper *,\r\n  .scheduleTable,\r\n  .scheduleTable * {\r\n    visibility: visible;\r\n  }\r\n\r\n  .p-dialog,\r\n  .p-dialog-content,\r\n  .tableModal,\r\n  .scheduleTablesWrapper {\r\n    overflow: visible !important;\r\n  }\r\n\r\n  .tableModal {\r\n    position: static !important;\r\n    width: 100% !important;\r\n    height: auto !important;\r\n    max-width: none !important;\r\n    max-height: none !important;\r\n    background-color: #fff !important;\r\n    border-radius: 0 !important;\r\n    box-shadow: none !important;\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .tableModal :global(.p-dialog) {\r\n    position: static !important;\r\n    border-radius: 0 !important;\r\n    background-color: #fff !important;\r\n    box-shadow: none !important;\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n    width: 100% !important;\r\n    height: auto !important;\r\n    max-width: none !important;\r\n    max-height: none !important;\r\n  }\r\n\r\n  .tableModal :global(.p-dialog-footer) {\r\n    display: none !important;\r\n  }\r\n\r\n  .tableModal :global(.p-dialog-header) {\r\n    display: none !important;\r\n  }\r\n\r\n  .tableModal :global(.p-dialog-content) {\r\n    display: block !important;\r\n    flex-direction: unset !important;\r\n    align-items: unset !important;\r\n    justify-content: unset !important;\r\n    overflow: visible !important;\r\n    height: auto !important;\r\n    max-height: none !important;\r\n    background-color: #fff !important;\r\n  }\r\n\r\n  .tableModal {\r\n    position: static !important;\r\n    display: block !important;\r\n    width: 100% !important;\r\n    height: auto !important;\r\n    overflow: visible !important;\r\n    background-color: #fff !important;\r\n  }\r\n\r\n  .scheduleTablesWrapper {\r\n    display: block !important;\r\n    overflow: visible !important;\r\n    width: 100% !important;\r\n  }\r\n\r\n  .scheduleTable {\r\n    background: #fff !important;\r\n    padding: 20px !important;\r\n    border-radius: 0 !important;\r\n    margin-bottom: 30px !important;\r\n    border: 1px solid #ddd !important;\r\n    break-inside: avoid-page;\r\n    page-break-inside: avoid;\r\n  }\r\n\r\n  .scheduleTable h3 {\r\n    color: #000 !important;\r\n    font-size: 18px !important;\r\n    margin-bottom: 15px !important;\r\n    font-weight: bold !important;\r\n  }\r\n\r\n  .scheduleTable :global(.p-datatable) {\r\n    border: 1px solid #ddd !important;\r\n  }\r\n\r\n  .scheduleTable :global(.p-datatable-thead) {\r\n    background-color: #f5f5f5 !important;\r\n  }\r\n\r\n  .scheduleTable :global(.p-datatable-table) {\r\n    table-layout: fixed !important;\r\n    width: 100% !important;\r\n    border-radius: 0 !important;\r\n  }\r\n\r\n  .scheduleTable :global(.p-datatable-thead th),\r\n  .scheduleTable :global(.p-datatable-tbody td) {\r\n    width: 14.28% !important;\r\n    word-wrap: break-word;\r\n  }\r\n\r\n  .scheduleTable :global(.p-datatable-thead th) {\r\n    background-color: #f5f5f5 !important;\r\n    color: #000 !important;\r\n    border: 1px solid #ddd !important;\r\n    padding: 12px 8px !important;\r\n    font-weight: bold !important;\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  .scheduleTable :global(.p-datatable-tbody td) {\r\n    border: 1px solid #ddd !important;\r\n    padding: 10px 8px !important;\r\n    color: #000 !important;\r\n    background-color: #fff !important;\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  .scheduleTable :global(.p-datatable-tbody tr:nth-child(even)) {\r\n    background-color: #fff !important;\r\n  }\r\n\r\n  @page {\r\n    margin: 1in;\r\n    size: auto;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `RcDRs9qQqYoka1PA`;
export var pageHeader = `JQFNr2nfO3c9C0gJ`;
export var dropdown = `BBF2Uk2nNkwEsSWA`;
export var actions = `Y45RwsiCdkUiWQTT`;
export var left = `ulhTbWvVVcza2fVz`;
export var toggleWrapper = `I_KMVOg9BicXxGHZ`;
export var dragCreateBtn = `RRsNgNubiqg90YTc`;
export var saveBtn = `leZC90SN5IIhXR4d`;
export var deleteSlot = `c0nh_l3MfIEGYbpo`;
export var calendarWrapper = `FYA6W8TzDs80VQQx`;
export var weekdaySwitcher = `W2KH_loQREi3aqyN`;
export var alertModal = `yMuW4J7rBlkJdAsk`;
export var text = `S4jtA2TpTioWQSiD`;
export var confirmDialogBtn = `hxOhZOTSc7IkzY9y`;
export var cancelDialogBtn = `epPiET8eVIMmktj1`;
export var scheduleDropdownPanel = `FEttFQmJH8LYdOlL`;
export var dropdownGroupHeader = `ree0GQeW9QAqySNu`;
export var dropdownGroupBadge = `Goy6yixXzk3axnwZ`;
export var dropdownSubItem = `roZ0EtjDT4IuyfJj`;
export var selectorWrapper = `YnC6PAsbUUA4LiTg`;
export var scheduleTableBtn = `hIdegu3H90ajfyz3`;
export var scheduleFilterDropdown = `fM0I_G5fATI2nFWq`;
export var scheduleFilterDropdownPanel = `zBmtHL2UEXQ3Za5i`;
export var scheduleTablesWrapper = `OF9EA2ZHZP0YP9li`;
export var multiStationSectionLabel = `J9SdydU7uA0h2ZDR`;
export var scheduleTableSub = `bQqcIMw6g1YIQAkp`;
export var scheduleTable = `SRTGMONRvoZXZnBl`;
export var modalHeaderWrapper = `hK8i7XV9re8LTjcL`;
export var modalHeaderBts = `IFaJcpsyjEg6rJnp`;
export var tableModal = `IwlZByC8W2Qpn3ZP`;
export var weekdayBtn = `YYcuqxaJ7EQk3MR_`;
export var selected = `ZkJC_81rvUo6Gt1_`;
export var createSlot = `MObukh2ouDULzNZD`;
export var saveBtnWrapper = `kZF6N_DhccovL_oA`;
var _1 = `QJGk83VAn4Y9HySU`;
export { _1 as "p-dialog" };
var _2 = `CK2__HNeQmg800iG`;
export { _2 as "p-dialog-content" };
export default ___CSS_LOADER_EXPORT___;
